import { clientFetch } from '../clientFetch';

export const validateNPI = (NPI) => {
  return clientFetch(`/validate/npi`, {
    params: { NPI },
  });
};
